import React from 'react';
import classNames from 'classnames';

interface IProps {
  count?: number;
  children: React.ReactNode;
  onClick?: (e) => void;
}

interface ClassnameProps {
  withDropdown?: boolean;
  selected?: boolean;
  count?: number;
  mobileOnlyCount?: boolean;
  loading?: boolean;
}

export default function FilterChip(props: IProps & ClassnameProps) {
  const {
    count,
    children,
    onClick,
  } = props;
  return (
    <button
      type="button"
      className={filterChipClasses(props)}
      onClick={onClick}
    >
      {children}
      <span className="filter-chip__count">{count}</span>
    </button>
  );
}

export function filterChipClasses(props: ClassnameProps) {
  const {
    withDropdown = false,
    selected = false,
    count = 0,
    mobileOnlyCount = false,
    loading = false,
  } = props;
  return classNames(
    'filter-chip',
    { 'filter-chip--with-dropdown': withDropdown },
    { 'filter-chip--with-count': count > 1 && !mobileOnlyCount },
    { 'filter-chip--with-mobile-count': count > 0 && mobileOnlyCount },
    { 'filter-chip--selected': selected },
    { 'filter-chip--loading': loading },
  );
}
